import { IAppState } from '../../common/state';
import { IFlatTourBookingInfo } from '../../types/newbuildingHeader';

export function getFlatTourBookingInfo({ newbuildingInformation }: IAppState): IFlatTourBookingInfo | null {
  return newbuildingInformation?.flatTourBookingInfo || null;
}
